export default function InvestorPortalTabNav({ tabs, activeKey, onChange }) {
  return (
    <nav className="investor-portal-tabs mb-3" aria-label="Section navigation">
      {tabs.map((t) => (
        <button
          key={t.key}
          type="button"
          className={`investor-portal-tab${activeKey === t.key ? " investor-portal-tab--active" : ""}`}
          onClick={() => onChange(t.key)}
        >
          {t.label}
        </button>
      ))}
    </nav>
  );
}
